import type { FeedbackSource } from "@domains/feedback/shared/feedbackTypes.ts";
import type { FeedbackReportType } from "#shared/feedbackReportFilters.ts";

const FEEDBACK_REPORT_TYPE_BY_SOURCE: Record<FeedbackSource, FeedbackReportType> = {
    Officevibe: "Pulse",
    Custom: "CustomQuestions",
    Onboarding: "Onboarding",
    Smart: "Smart",
    NonSurvey: "Suggestion"
};

export function toFeedbackReportType(source: FeedbackSource): FeedbackReportType {
    return FEEDBACK_REPORT_TYPE_BY_SOURCE[source];
}
